// Single source of truth for turning a Postgres unique-constraint rejection
// (SQLSTATE 23505) on the `members` table into a clear, field-specific message.
//
// Shared by every surface that writes member identity fields — Add Member,
// admin Edit member, and the member's own notification-preference update — so
// all three report the SAME honest reason instead of a generic "try again".
//
// Covers the four per-group partial unique indexes (whatsapp / sms / email /
// name) plus the GLOBAL phone anchor (members_phone_e164_key, the phone+PIN
// login uniqueness). Returns null for anything that isn't a recognized member
// constraint (including non-23505 errors) so the caller keeps its own fallback.
export function memberConstraintMessage(err) {
  if (err?.code !== '23505') return null;
  const m = err.message || '';
  if (m.includes('members_group_phone_uniq')) return 'This WhatsApp number is already in use in this group.';
  if (m.includes('members_group_sms_uniq'))   return 'This SMS number is already in use in this group.';
  if (m.includes('members_group_email_uniq')) return 'This email is already in use in this group.';
  if (m.includes('members_group_name_uniq'))  return 'This name is already in use in this group.';
  if (m.includes('members_phone_e164_key')) {
    // GLOBAL phone uniqueness (phone+PIN login anchor): the same phone already
    // exists on ANY group's member. Login currently assumes one phone → one
    // member; multi-group membership is a deferred build, so this is expected.
    return 'This phone number is already registered to a member (in this or another group). Phone numbers must be unique across the app while phone + PIN login is in use.';
  }
  return null;
}
